import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {RequestVisitorDto} from "../../../../../modules/vms/dto/RequestVisitorDto";
import NumberKeyboard from "../../../../../components/keyboard/NumberKeyboard";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField} from "@mui/material";

import "./VisitCodeInputDialog.css";
import GppGoodIcon from '@mui/icons-material/GppGood';
import {VisitRequestDto} from "../../../../../modules/vms/dto/VisitRequestDto";
import CancelIcon from "@mui/icons-material/Cancel";
import {RequestVisitorApi} from "../../../../../modules/vms/api/RequestVisitorApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";

export type VisitCodeInputDialogProps = {
    open: boolean;
    onVerified: (requestVisitor: RequestVisitorDto) => void;
    onClose: () => void;
};

const VisitCodeInputDialog: React.FC<VisitCodeInputDialogProps> = (props) => {
    const intl = useIntl();

    const [visitCode, setVisitCode] = useState('');

    useEffect(() => {
        if (props.open) {
            setVisitCode('');
        }
    }, [props.open]);

    const handleVerify = async () => {
        if (visitCode) {
            // // 测试
            // const newRequestVisitor = new RequestVisitorDto();
            // newRequestVisitor.fullName = '测试用户';
            // newRequestVisitor.mobile = '13812345678';
            // newRequestVisitor.email = '13812345678@163.com';
            // newRequestVisitor.company = 'qq';
            // newRequestVisitor.visitRequest = new VisitRequestDto();
            // newRequestVisitor.visitRequest.classify = visitCode;
            // newRequestVisitor.visitRequest.hostFullName = '接待者123';
            // newRequestVisitor.visitRequest.hostStaffNumber = 'A123456';
            // newRequestVisitor.visitRequest.hostMobile = '13512345678';
            // newRequestVisitor.visitRequest.hostEmail = '13512345678@163.com';
            const responseResult = await RequestVisitorApi.getAvailableVisitor(visitCode);
            if (responseResult.status === HttpStatus.SUCCESS) {
                props.onVerified(responseResult.data);
                props.onClose();
            }
        }
    }

    return (
        <Dialog open={props.open}>
            <DialogTitle>
                {intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE_VERIFY'})}
            </DialogTitle>
            <DialogContent>
                <Stack justifyContent={'center'}
                       alignItems="center" spacing={2}>
                    <div className={'self-terminal-visit-code-input'}>
                        <TextField label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE'})}
                                   placeholder={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE_REQUIRED'})}
                                   variant="outlined"
                                   InputLabelProps={{
                                       shrink: true,
                                   }}
                                   InputProps={{
                                       readOnly: true,
                                   }}
                                   fullWidth
                                   value={visitCode}/>
                    </div>
                    <NumberKeyboard onChange={(value) => setVisitCode(value)}/>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" size="large" color={"secondary"}
                        startIcon={<CancelIcon/>}
                        onClick={() => props.onClose()}>
                    <FormattedMessage id={'COMMON_CLOSE'}/>
                </Button>
                <Button variant="contained"
                        size="large" startIcon={<GppGoodIcon/>} onClick={() => handleVerify()}>
                    <FormattedMessage id={'VMS_REQUEST_VISITOR_VISIT_CODE_VERIFY'}/>
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VisitCodeInputDialog;